import inContextHelpBundle from './bundles/inContextHelp.json';

/**
 * The locale code to render the studio in. We'll rely on this locale code instead of the user's
 * locale code since the studio is only supposed to render in English.
 * 
 * If set to `undefined`, the webapp will attempt to rely on the user's locale code which may have
 * unexpected results.
 */
export const localeCode = 'en-US';

/**
 * The names of the CMX projects this webapp relies on.
 */
export const requiredCmxProjectNames = [ 'navigation', 'tributary-in-context-help' ];

/**
 * Retrieves a language bundle from local files. Ideally this will never be used and we'd instead
 * rely on language bundles retrieved from CMX.
 * 
 * @param { string } projectName - The name of the project to retrieve.
 * @param { string } localeCode - The locale code of the translations you wish to retrieve.
 * @returns { object | null }
 */
export function getLocalLanguageBundle( projectName, localeCode = 'en-US' ) {
    const bundles = [ ...inContextHelpBundle, /* ... */ ];

    // Attempt to find the local language bundle.
    for ( let i = 0; i < bundles.length; i++ ) {
        if ( bundles[ i ].projectName === projectName && bundles[ i ].bundles[ localeCode ] ) {
            return bundles[ i ].bundles[ localeCode ];
        }
    }

    return null;
}
